import { useUser } from 'providers/Auth';

import { Column } from 'components/Blocks';
import { LogoBubble } from 'components/Logos';
import { IncentiveProgress } from 'components/Rewards';
import { EmailConfirm } from 'components/EmailConfirmation';

import { MobileIncentiveTab } from './MobileIncentiveTab';

import { WppConfirm } from './Whatsapp';
import { useWindowSize } from 'hooks';

export function SidePoints() {
  const { firstName, emailConfirmed } = useUser();

  const { breakpoints } = useWindowSize();

  const isMobile = breakpoints.SMALL_TABLET;

  if (isMobile)
    return (
      <>
        {emailConfirmed ? <WppConfirm /> : <EmailConfirm />}

        <MobileIncentiveTab />
      </>
    );

  return (
    <Column className="items-center pt-10 small_tablet:pt-4" gap="8">
      <Column>
        <LogoBubble />

        <strong className="text-center text-xl font-semibold text-foreground-title">
          {firstName}
        </strong>
      </Column>

      <IncentiveProgress />

      <Column className='[&>button]:w-full'>
        <WppConfirm />

        <EmailConfirm />
      </Column>
    </Column>
  );
}
